// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Slots_wrapper__1JApn","slot":"Slots_slot__2PA_w","active":"Slots_active__1y1Uq"};